import {openResourceModal} from '../../core/modalCommand';
import {reportActiveAgentModalLifecycle} from '../../core/modalLifecycle';
import {
	ACTIVE_ALARMS_ACK_MODAL_EVENT,
	ACTIVE_ALARMS_CONFIGURE_MODAL_EVENT,
	HISTORICAL_ALARMS_DELETE_MODAL_EVENT,
} from './events';

/**
 * Open the Active Alarms Acknowledge modal.
 * @param {object} command modal command
 * @param {object} envelope request correlation
 * @return {Promise<void>} modal acknowledgement
 */
export function openAlarmsAcknowledgeModal(command, envelope) {
	return openResourceModal(
		ACTIVE_ALARMS_ACK_MODAL_EVENT,
		command,
		envelope,
	);
}

/**
 * Open the Configure Alarms form.
 * @param {object} command modal command
 * @param {object} envelope request correlation
 * @return {Promise<void>} modal acknowledgement
 */
export function openAlarmsConfigureModal(command, envelope) {
	return openResourceModal(
		ACTIVE_ALARMS_CONFIGURE_MODAL_EVENT,
		command,
		envelope,
	);
}

/**
 * Open Historical Alarm delete confirmation.
 * @param {object} command modal command
 * @param {object} envelope request correlation
 * @return {Promise<void>} modal acknowledgement
 */
export function openHistoricalAlarmsDeleteModal(command, envelope) {
	return openResourceModal(
		HISTORICAL_ALARMS_DELETE_MODAL_EVENT,
		command,
		envelope,
	);
}

/**
 * Report an Alarms modal outcome.
 * @param {'modal.cancelled'|'modal.saved'|'modal.failed'} eventType lifecycle event
 * @param {string|null} [errorCode] failure reason when the save did not complete
 * @return {Promise<object|null>} agent response
 */
export function reportAlarmsModalLifecycle(eventType, errorCode = null) {
	return reportActiveAgentModalLifecycle(eventType, errorCode);
}
